import { render } from "./_form-button2.vue?vue&type=template&id=6365aa33"
import script from "./_form-button2.vue?vue&type=script&lang=js"
export * from "./_form-button2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__